// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"OrderManagement--next-sr-only--1lnaKM-","container":"OrderManagement--container--2xj_bcH","searchInput":"OrderManagement--searchInput--N7scfWv"};